(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wishlist-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'hob_wishlist';
    function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    function render() {
      var list = read();
      document.querySelectorAll('.hob-wl').forEach(function (el) {
        var h = el.getAttribute('data-handle');
        var on = list.indexOf(h) !== -1;
        var btn = el.querySelector('.hob-wl__add');
        var label = el.querySelector('.hob-wl__label');
        if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (label) label.textContent = on ? 'In your wishlist' : 'Add to wishlist';
        var c = el.querySelector('.hob-wl__count');
        if (c) c.textContent = String(list.length);
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.hob-wl__add');
      if (!btn) return;
      var el = btn.closest('.hob-wl');
      var h = el && el.getAttribute('data-handle');
      if (!h) return;
      var list = read();
      var i = list.indexOf(h);
      if (i === -1) list.push(h); else list.splice(i, 1);
      write(list);
      render();
    });
    window.addEventListener('storage', render);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
    document.addEventListener('shopify:section:load', render);
  })();
  } catch(e) { console.error(e); }
})();

})();
